import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API || 'http://127.0.0.1:5005'
});

const login = (email, password) => {
  return instance.post('/auth', {
    email: email,
    password: password
  })
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const logout = () => {
  localStorage.removeItem('token')
}
export {
  login,
  logout,
}
